<template>
    <div class="container">
        <div class="row no-gutters pt-xl-4" v-if="element">
            <div class="col-xl-3 col-6 tab-video-bird order-xl-1 order-2">

            </div>
            <div class="col-xl-6 col-12 tab-video-title order-xl-2 order-1 text-center pt-xl-3 mt-xl-0 mt-4">
                {{element.element}}
            </div>
            <div class="col-xl-3 col-6 tab-video-points order-xl-3 order-3">
                <div class="zerno-points" v-if="!hidePoints">
                    {{points}}
                </div>
            </div>
            <div class="col-xl-12 col-12 tab-video-notice order-xl-4 order-4 text-center mt-xl-n6 mt-n5 mb-xl-0 mb-3">
                <div class="tab-video-notice-1">{{ $t('lesson') }}</div>
                <div class="tab-video-notice-2 pl-xl-0 pl-6 pr-xl-0 pr-6">{{element.description}}
                </div>
            </div>
            <div class="col-12 order-4 order-xl-4 mt-xl-4 mb-xl-5">
                <div class="video-wrapper" @contextmenu.prevent="handler">
                    <video-player class="vjs-custom-skin"
                                  ref="videoPlayer"
                                  :options="playerOptions"
                                  customEventName="changed"
                                  :playsinline="true"
                                  @timeupdate="timeupdate"
                                  @ended="ended"
                                  @loadeddata="loadeddata">
                    </video-player>
                </div>
            </div>
            <div class="col-12 order-5 mb-xl-6 mb-6">
                <div class="row justify-content-center text-center">
                    <div class="col-xl-auto col-12" v-if="!isAndroidApp()">
                        <base-button class="btn-to-lessons-list pl-5 pr-5 mt-xl-0 mt-4" size="lg"
                                     @click="toLessons">
                            <i class="fa fa-bars"></i> {{ $t('to_lessons_list') }}
                        </base-button>
                    </div>
                    <div class="col-xl-auto col-12" v-if="!hideToTest">
                        <base-button class="btn-to-next-lesson pl-5 pr-5 mt-xl-0 mt-4" icon="ni ni-curved-next"
                                     size="lg"
                                     @click="toTests">
                            {{ $t('to_tests') }}<!--<i class="fa fa-arrow-right"></i>-->
                        </base-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style src="@/assets/poliglotiki/main.css">
</style>
<script>
    import 'video.js/dist/video-js.css'
    import '@/assets/poliglotiki/custom-theme.css'

    import {videoPlayer} from 'vue-video-player'
    import {isAndroid} from "../data/AndroidApi";

    export default {
        props: ['points', 'element', 'lesson', 'hideToTest', 'hidePoints'],
        name: "LessonVideo",
        components: {
            videoPlayer,
        },
        data() {
            return {}
        },

        methods: {
            handler(e) {
                e.preventDefault();
            },

            toTests() {
                this.$emit('totests')
            },

            toLessons() {
                this.$emit('tolessons')
            },

            timeupdate(player) {
                this.$emit('timeupdate', player)
            },

            loadeddata(player) {
                this.$emit('loadeddata', player)
            },

            ended(player) {
                this.$emit('ended', player)
            },

            isAndroidApp() {
                console.log("isAndroid", isAndroid())
                return isAndroid()
            },
        },

        computed: {
            playerOptions() {
                return {
                    poster: this.element.video_preview,
                    sources: [{
                        //type: 'video/mp4',
                        src: this.element.url
                    }],
                    language: 'ru',
                    fluid: true,
                    width: '100%',
                }
            }
        },

        mounted() {

        }
    }
</script>

<style scoped>

</style>
